<app-site-widget
    *ngIf="data"
	[title]="title"
	[tooltipText]="tooltipText"
	[elementId]="elementId"
	chartType="progress"
	[widgetClass]="widgetClass"
	[siteWidgetOptions]="siteWidgetOptions"
	[widgetOptions]="{hasExport: true}"
	(eventEmit)="eventEmit($event)"
	[data]="data"
	[hideTable]="true"
	[hideDevs]="true"
	[titleStyle]="true"
	[tagStyle]="true"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>





